import { ContextStore } from 'bernie-core';

import { getUpdatedCriteria } from 'stores/adapters/bex-api/property-info';

import { bffFetch, Headers } from './bff-fetch';

export class HotelOffersSource {
  private host: string;
  private logger: any;
  private forwardedHeaders: Headers;

  constructor(host = '', logger = {}, forwardedHeaders: Headers = {}) {
    this.host = host;
    this.logger = logger;
    this.forwardedHeaders = forwardedHeaders;
  }

  public fetch(context: ContextStore, criteria: any, hotelId: number, travelAd: any) {
    const data = getUpdatedCriteria(criteria, travelAd);

    return bffFetch(this.host, `hotel/${hotelId}/offers`, context, data, this.logger, this.forwardedHeaders);
  }
}
